import { createFeatureSelector, createSelector } from "@ngrx/store";
import { BuscadorPersonasState } from "./buscador-personas.reducer";
import * as fromBuscadorPersonas from "./buscador-personas.reducer";

export const buscadorPersonasState = createFeatureSelector<BuscadorPersonasState>( "buscador-personas" );

export const buscadorPersonas = createSelector(
	buscadorPersonasState,
	fromBuscadorPersonas.selectAll
);

export const buscadorPersonasReady = createSelector(
	buscadorPersonasState,
	state => state.ready
);

export const buscadorPersonasNextPageNum = createSelector(
	buscadorPersonasState,
	state => state.nextPageNum
);

export const buscadorPersonasPageSize = createSelector(
	buscadorPersonasState,
	state => state.pageSize
);

export const buscadorPersonasMorePagesToLoad = createSelector(
	buscadorPersonasState,
	state => state.morePagesToLoad
);

export const buscadorTotalPersonas = createSelector(
	buscadorPersonasState,
	state => state.total
);

export const buscadorInputText = createSelector(
	buscadorPersonasState,
	state => state.inputText
);

export const buscadorPersonaFoto = createSelector(
	buscadorPersonasState,
	state => ( idUsuarioMf: number ) => state.personasFoto ? state.personasFoto[ idUsuarioMf ] : null
);

export const buscadorPersonaEntityFunc = createSelector(
	buscadorPersonasState,
	state => ( idUsuarioMf: number ) => state.entities ? state.entities[ idUsuarioMf ] : null
);

// Toggle Collapse
export const buscadorPersonaCollapse = createSelector(
	buscadorPersonasState,
	state => ( idPersona: number ) => state.collapse ? state.collapse[ idPersona ] : null
);